//专场数据
import fetchJsonp from "fetch-jsonp";

const jobSpecialData = [
  [
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/338",
      organizer: "58同城·招聘",
      province: "安徽省 · 合肥市",
      spareaIds: "1369182526223953920",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejihefei",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/351",
      organizer: "58同城·招聘",
      province: "北京市",
      spareaIds: "1368815210902593536",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyeji-beijing",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/363",
      organizer: "福州市台江区人力资源和社会保障局 58同城·招聘",
      province: "福建省 · 福州市",
      spareaIds: "1369157315302793216",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejifuzhou",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/342",
      organizer: "58同城·招聘",
      province: "福建省 · 厦门市",
      spareaIds: "1369179696201216001",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejixiamen",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/361",
      organizer: "58同城·招聘",
      province: "广东省 · 东莞市",
      spareaIds: "1368821390416814081",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyeji-dongguan",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/364",
      organizer: "广州市天河区人力资源和社会保障局 天河人才港 58同城·招聘",
      province: "广东省 · 广州市",
      spareaIds: "1369196856332001280",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejiguangzhou",
    },
  ],
  [
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/343",
      organizer: "58同城·招聘",
      province: "广东省 · 惠州市",
      spareaIds: "1369184736903176192",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejihuizhou",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/368",
      organizer:
        "深圳市盐田区人力资源局 深圳市盐田区退役军人事务局 58同城·招聘",
      province: "广东省 · 深圳市",
      spareaIds: "1369167304033579008",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejishenzhen",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/362",
      organizer: "南宁市兴宁区人力资源和社会保障局 58同城·招聘",
      province: "广西省 · 南宁市",
      spareaIds: "1368824969475137536",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejinanning",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/358",
      organizer: "58同城·招聘",
      province: "河北省 · 石家庄市",
      spareaIds: "1369168980832428032",
      pcUrl:"hhttp://hrgactivity.58.com/render/nuanchunjiuyejishijiazhuang",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/344",
      organizer: "58同城·招聘",
      province: "河南省 · 郑州市",
      spareaIds: "1369188926408896512",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejizhengzhou",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/352",
      organizer: "58同城·招聘",
      province: "黑龙江省 · 哈尔滨市",
      spareaIds: "1369207082393280512",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejihaerbin",
    },
  ],
  [
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/345",
      organizer: "58同城·招聘",
      province: "湖北省 · 武汉市",
      spareaIds: "1369186728820088832",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejiwuhan",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/346",
      organizer: "58同城·招聘",
      province: "湖南省 · 长沙市",
      spareaIds: "1369160103051145217",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejichangsha",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/354",
      organizer: "58同城·招聘",
      province: "吉林省 · 长春市",
      spareaIds: "1369175229728829441",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejichangchun",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/341",
      organizer: "58同城·招聘",
      province: "江苏省 · 昆山市",
      spareaIds: "1369132344102887424",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejikunshan",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/340",
      organizer: "58同城·招聘",
      province: "江苏省 · 南京市",
      spareaIds: "1369177336066355200",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejinanjing",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/339",
      organizer: "58同城·招聘",
      province: "江苏省 · 苏州市",
      spareaIds: "1369173725051625473",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejisuzhou",
    },
  ],
  [
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/360",
      organizer: "58同城·招聘",
      province: "江苏省 · 无锡市",
      spareaIds: "1369202610900316160",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejiwuxi",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/355",
      organizer: "58同城·招聘",
      province: "辽宁省 · 大连市",
      spareaIds: "1369163312947802112",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejidalian",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/353",
      organizer: "58同城·招聘",
      province: "辽宁省 · 沈阳市",
      spareaIds: "1369134539124781056",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejishenyang",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/357",
      organizer: "山东省妇女联合会 山东省妇女创业发展服务中心 58同城·招聘",
      province: "山东省 · 济南市",
      spareaIds: "1369165313161048064",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejijinan",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/359",
      organizer: "58同城·招聘",
      province: "山东省 · 青岛市",
      spareaIds: "1369190819604475904",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejiqingdao",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/356",
      organizer: "58同城·招聘",
      province: "山西省 ·太原市",
      spareaIds: "1369128689031192577",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejitaiyuan",
    },
  ],
  [
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/349",
      organizer: "58同城·招聘",
      province: "上海市",
      spareaIds: "1369161279394029568",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejishanghai",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/348",
      organizer: "58同城·招聘",
      province: "四川省 · 成都市",
      spareaIds: "1369198719118880768",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejichengdu",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/350",
      organizer: "58同城·招聘",
      province: "天津市",
      spareaIds: "1369195199716139008",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejitianjin",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/337",
      organizer: "58同城·招聘",
      province: "浙江省 · 杭州市",
      spareaIds: "1369203410649231362",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejihangzhou",
    },
    {
      linkUrl: "https://hrgserver.58.com/yytmp/app/online/347",
      organizer: "58同城·招聘",
      province: "重庆市",
      spareaIds: "1369158375870308352",
      pcUrl:"http://hrgactivity.58.com/render/nuanchunjiuyejichongqing",
    },
  ],
];

let idArr = [];
let spareaIdArr = [];
jobSpecialData.map((item) => {
  item.map((item) => {
    idArr.push(parseInt(item.linkUrl.substring(42)));
    spareaIdArr.push(item.spareaIds);
  });
});
let idStr = idArr.toString();
export let spareaIdStr = spareaIdArr.toString();
let jobList = [];
export let DataFn = fetchJsonp(
  "//hrgserver.58.com/yytmp/getdata/app/online/" + idStr
)
  .then(function (response) {
    return response.json();
  })
  .then(function (json) {
    jobList = json.data.onlineData;
    jobSpecialData.map((item, index) => {
      let a = index;
      item.map((item, index) => {
        item["pageTitle"] =
          jobList[parseInt(a * 6 + index)].pageGlobalConfig.pageTitle;
        item["startTime"] = jobList[parseInt(a * 6 + index)]._redisStartTime;
        item["endTime"] = jobList[parseInt(a * 6 + index)]._redisEndTime;
        item["imgUrl"] =
          jobList[parseInt(a * 6 + index)].pageGlobalConfig.shareConfigInfo
            .imgUrl || "";
        item["id"] = idArr[parseInt(a * 6 + index)];
      });
    });
    return jobSpecialData;
  })
  .catch(function (ex) {
    console.log("parsing failed", ex);
  });
